<template>
  <div class="bsdwzCN">
    <!-- ==================== 1、需要解决的视觉问题 ==================== -->
    <p class="bt1">1、需要解决的视觉问题有:</p>
    <!-- InquiryIntention: List<bool> 复选，11项 -->
    <div class="sjwt">
      <p>
        <el-checkbox :value="!!form.InquiryIntention[0]" @input="(v) => $set(form.InquiryIntention, 0, v ? true : false)"> 看远模糊</el-checkbox>
        <span>度数变化;眼健康问题</span>
      </p>
      <p>
        <el-checkbox :value="!!form.InquiryIntention[1]" @input="(v) => $set(form.InquiryIntention, 1, v ? true : false)">看近模糊</el-checkbox>
        <span>双眼视功能异常</span>
      </p>
      <p>
        <el-checkbox :value="!!form.InquiryIntention[2]" @input="(v) => $set(form.InquiryIntention, 2, v ? true : false)">眼睛干涩</el-checkbox>
        <span>干眼问题；</span>
      </p>
    </div>
    <div class="sjwt">
      <p>
        <el-checkbox :value="!!form.InquiryIntention[3]" @input="(v) => $set(form.InquiryIntention, 3, v ? true : false)">胀疼疲劳</el-checkbox>
        <span style="width: 90%;">排查双眼视功能异常;度数未正确矫正;老花未矫正;眼压异常</span>
      </p>
      <p>
        <el-checkbox :value="!!form.InquiryIntention[4]" @input="(v) => $set(form.InquiryIntention, 4, v ? true : false)">眼睛痒</el-checkbox>
        <span>干眼问题;眼表疾病</span>
      </p>
      <p>
        <el-checkbox :value="!!form.InquiryIntention[5]" @input="(v) => $set(form.InquiryIntention, 5, v ? true : false)">怕光</el-checkbox>
        <span>屈光不正;弱视;角膜健康问题;激光手术术后</span>
      </p>
    </div>
    <div class="sjwt">
      <p>
        <el-checkbox :value="!!form.InquiryIntention[6]" @input="(v) => $set(form.InquiryIntention, 6, v ? true : false)">视物扭曲变形</el-checkbox>
        <span>散光度数变化;镜片老化变形;黄斑病变;</span>
      </p>
      <p>
        <el-checkbox :value="!!form.InquiryIntention[7]" @input="(v) => $set(form.InquiryIntention, 7, v ? true : false)">夜间视力差</el-checkbox>
        <span>屈光术后眩光;度数未正确矫正;高阶像差;夜盲症</span>
      </p>
      <p>
        <el-checkbox :value="!!form.InquiryIntention[8]" @input="(v) => $set(form.InquiryIntention, 8, v ? true : false)">听力问题的困扰</el-checkbox>
        <span>是否有听力损伤,如果有需要检查听力</span>
      </p>
    </div>
    <div class="sjwt">
      <p>
        <el-checkbox :value="!!form.InquiryIntention[9]" @input="(v) => $set(form.InquiryIntention, 9, v ? true : false)">验光配镜</el-checkbox>
      </p>
      <p>
        <el-checkbox :value="!!form.InquiryIntention[10]" @input="(v) => $set(form.InquiryIntention, 10, v ? true : false)"> 复查管理</el-checkbox>
      </p>
      <p></p>
    </div>
    <!-- InquiryIntentionDes: 其它主诉，填写 -->
    <div class="qitsq">
      <p>本次其他主诉需求:</p>
      <input type="text" v-model="form.InquiryIntentionDes">
    </div>



    <!-- ==================== 2、旧镜史相关 ==================== -->
    <p class="bt1" style="margin-top: 30px;">2、旧镜史相关:</p>
    <!-- InquiryCorrection: List<bool> 既往矫正方式，复选，6个 -->
    <div class="slxgbox" style="border-bottom: none; ">
      <div class="slxgbox-a" style="width: 100%;">
        <p>.既往矫正方式</p>
        <p>了解既往矫正方式是否对本次验光准确性有影响,为本次矫正方式选择提供参考</p>
        <div style="display: flex;padding-top: 10px;flex-wrap: wrap;">
          <el-checkbox :value="!!form.InquiryCorrection[0]" @input="(v) => $set(form.InquiryCorrection, 0, v ? true : false)">框架眼镜</el-checkbox>
          <el-checkbox :value="!!form.InquiryCorrection[1]" @input="(v) => $set(form.InquiryCorrection, 1, v ? true : false)">软性角膜接触镜</el-checkbox>
          <el-checkbox :value="!!form.InquiryCorrection[2]" @input="(v) => $set(form.InquiryCorrection, 2, v ? true : false)">RGP</el-checkbox>
          <el-checkbox :value="!!form.InquiryCorrection[3]" @input="(v) => $set(form.InquiryCorrection, 3, v ? true : false)">OK镜</el-checkbox>
          <el-checkbox :value="!!form.InquiryCorrection[4]" @input="(v) => $set(form.InquiryCorrection, 4, v ? true : false)">屈光手术</el-checkbox>
          <el-checkbox :value="!!form.InquiryCorrection[5]" @input="(v) => $set(form.InquiryCorrection, 5, v ? true : false)">其他</el-checkbox>
        </div>
      </div>
    </div>
    <!-- InquiryFormerLensType: List<bool> 现在戴镜类型，复选，7个 -->
    <div class="slxgbox">
      <div class="slxgbox-a" style="width: 100%;">
        <p>.现在戴镜类型</p>
        <p>了解现在戴镜类型,为本次矫正方式选择提供参考</p>
        <div style="display: flex;padding-top: 10px;flex-wrap: wrap;">
          <el-checkbox :value="!!form.InquiryFormerLensType[0]" @input="(v) => $set(form.InquiryFormerLensType, 0, v ? true : false)">单光</el-checkbox>
          <el-checkbox :value="!!form.InquiryFormerLensType[1]" @input="(v) => $set(form.InquiryFormerLensType, 1, v ? true : false)">自由曲面</el-checkbox>
          <el-checkbox :value="!!form.InquiryFormerLensType[2]" @input="(v) => $set(form.InquiryFormerLensType, 2, v ? true : false)">数码</el-checkbox>
          <el-checkbox :value="!!form.InquiryFormerLensType[3]" @input="(v) => $set(form.InquiryFormerLensType, 3, v ? true : false)">渐进</el-checkbox>
          <el-checkbox :value="!!form.InquiryFormerLensType[4]" @input="(v) => $set(form.InquiryFormerLensType, 4, v ? true : false)">染色</el-checkbox>
          <el-checkbox :value="!!form.InquiryFormerLensType[5]" @input="(v) => $set(form.InquiryFormerLensType, 5, v ? true : false)">变色</el-checkbox>
          <el-checkbox :value="!!form.InquiryFormerLensType[6]" @input="(v) => $set(form.InquiryFormerLensType, 6, v ? true : false)">驾驶</el-checkbox>
        </div>
      </div>
    </div>
    <!-- InquiryFormerLensClear: string 现在戴镜清晰度 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.配戴清晰度：</p>
        <p>度数变化、眼健康问题,为本次验光度数调整提供依据;</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryFormerLensClear" label="不清">不清</el-radio>
        <el-radio v-model="form.InquiryFormerLensClear" label="良好">良好</el-radio>
      </div>
    </div>
    <!-- InquiryFormerLensComfortable: string 现在戴镜舒适度 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.配戴舒适度：</p>
        <p>了解旧镜配戴方式、镜架镜片选择等是否能提供舒适视觉,如果有问题,本次需针对检查并解决</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryFormerLensComfortable" label="不适">不适</el-radio>
        <el-radio v-model="form.InquiryFormerLensComfortable" label="良好">良好</el-radio>
      </div>
    </div>
    <!-- InquiryFitTimeForChange: string 每次换镜需要适应多长时间 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.每次换镜需要适应多长时间:</p>
        <p>了解眼睛适应能力,为本次处方提供参考</p>
      </div>
      <div><input type="text" v-model="form.InquiryFitTimeForChange">天</div>
    </div>
    <!-- InquiryChangeGlassesDegree: string 每次更换多少度 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.每次换镜度数是否变化:</p>
        <p>看是否及时更换眼镜;评估度数稳定情况</p>
      </div>
      <div><input type="text" v-model="form.InquiryChangeGlassesDegree">度</div>
    </div>
    <!-- InquiryGlassesAmount: string 有几副眼镜 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.常戴的眼镜有几副?</p>
        <p>了解不同用眼场景是否有对应功能的眼镜</p>
      </div>
      <div><input type="text" v-model="form.InquiryGlassesAmount">副</div>
    </div>
    <!-- InquiryShortDistance: bool 看近是否摘眼镜 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.看近是否摘眼镜?</p>
        <p>了解是否有近疲劳(老花);是否有双眼视功能异常</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryShortDistance" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryShortDistance" :label="false">否</el-radio>
      </div>
    </div>
    <!-- InquiryFullDay: bool 眼镜是否全天佩戴 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.眼镜是否全天候配戴?</p>
        <p>评估度数变化是否与不正确配戴方式有关;评估新镜适应情况</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryFullDay" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryFullDay" :label="false">否</el-radio>
      </div>
    </div>
    <!-- InquiryFormerLensProblem: string 现在的眼镜是否有以下问题 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.现在的眼镜是否有以下问题：</p>
        <p>评估旧镜视力是否有参考价值</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryFormerLensProblem" label="变形">变形</el-radio>
        <el-radio v-model="form.InquiryFormerLensProblem" label="磨损">磨损</el-radio>
      </div>
    </div>


    <!-- ==================== 3、用眼需求相关 ==================== -->
    <p class="bt1" style="margin-top: 30px;">3、用眼需求相关:</p>
    <!-- InquiryDriveTime: List<bool> 每天开车多长时间，单选 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.每天开车多长时间?</p>
        <p>了解远用视力需求;了解是否有驾驶需求</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio-group v-model="driveTime">
          <el-radio :label="0">基本不开</el-radio>
          <el-radio :label="1">一个小时以上</el-radio>
          <el-radio :label="2">3个小时以上</el-radio>
        </el-radio-group>
      </div>
    </div>
    <!-- InquiryNightDrive: List<bool> 夜间开车问题，单选 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.夜间开车是否有以下问题?</p>
        <p>是否需要使用驾驶镜片来解决驾驶安全问题</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio-group v-model="nightDrive">
          <el-radio :label="0">眩光</el-radio>
          <el-radio :label="1">光晕</el-radio>
          <el-radio :label="2">光线刺眼</el-radio>
        </el-radio-group>
      </div>
    </div>
    <!-- InquiryShortViewTime: List<bool> 每天近距离时长，单选 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.每天电脑、手机及近距离伏案工作时长</p>
        <p>了解近距离用眼量,评估双眼视功能和用眼需求是否匹配</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio-group v-model="shortViewTime">
          <el-radio :label="0">很少</el-radio>
          <el-radio :label="1">2小时以内</el-radio>
          <el-radio :label="2">4个小时以上</el-radio>
        </el-radio-group>
      </div>
    </div>
    <!-- InquiryOffLight: bool 是否关灯看电脑 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否有关灯看手机电脑的习惯?</p>
        <p>否有不良用眼习惯,影响眼健康</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryOffLight" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryOffLight" :label="false">否</el-radio>
      </div>
    </div>
    <!-- InquiryShortViewProblem: List<bool> 近距离用眼问题，复选，5个 -->
    <div class="slxgbox">
      <div class="slxgbox-a" style="width: 100%;">
        <p>.近距离用眼是否有以下问题?</p>
        <p>了解是否有双眼视功能异常的相关症状,好针对性的检查和处理</p>
        <div style="display: flex;padding-top: 10px;flex-wrap: wrap;">
          <el-checkbox :value="!!form.InquiryShortViewProblem[0]" @input="(v) => $set(form.InquiryShortViewProblem, 0, v ? true : false)">易疲劳</el-checkbox>
          <el-checkbox :value="!!form.InquiryShortViewProblem[1]" @input="(v) => $set(form.InquiryShortViewProblem, 1, v ? true : false)">头疼</el-checkbox>
          <el-checkbox :value="!!form.InquiryShortViewProblem[2]" @input="(v) => $set(form.InquiryShortViewProblem, 2, v ? true : false)">聚焦困难</el-checkbox>
          <el-checkbox :value="!!form.InquiryShortViewProblem[3]" @input="(v) => $set(form.InquiryShortViewProblem, 3, v ? true : false)">重影串行</el-checkbox>
          <el-checkbox :value="!!form.InquiryShortViewProblem[4]" @input="(v) => $set(form.InquiryShortViewProblem, 4, v ? true : false)">注意力不集中</el-checkbox>
        </div>
      </div>
    </div>
    <!-- InquiryChangeViewProblem: bool 远近交替是否模糊反应慢 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.视线远近交替是否有模糊,反应速度慢?</p>
        <p>了解是否有调节灵敏度的异常,好针对性的检查和处理</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryChangeViewProblem" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryChangeViewProblem" :label="false">否</el-radio>
      </div>
    </div>



    <!-- ==================== 4、主要用眼场景 ==================== -->
    <p class="bt1" style="margin-top: 30px;">4、主要用眼场景:</p>
    <!-- InquiryActivity: List<bool> 主要用眼场景，复选，7个 -->
    <div class="yycj">
      <el-checkbox :value="!!form.InquiryActivity[0]" @input="(v) => $set(form.InquiryActivity, 0, v ? true : false)">驾驶场景</el-checkbox>
      <p>了解是否需要用驾驶镜片来解决驾驶需求</p>
    </div>
    <div class="yycj">
      <el-checkbox :value="!!form.InquiryActivity[1]" @input="(v) => $set(form.InquiryActivity, 1, v ? true : false)">精准视觉</el-checkbox>
      <p>了解视力精准需求,为本次验光度数及镜片选择提供参考</p>
    </div>
    <div class="yycj">
      <el-checkbox :value="!!form.InquiryActivity[2]" @input="(v) => $set(form.InquiryActivity, 2, v ? true : false)">电子数码、阅读</el-checkbox>
      <p>了解是否需要使用数码镜片来解决用眼需求</p>
    </div>
    <div class="yycj">
      <el-checkbox :value="!!form.InquiryActivity[3]" @input="(v) => $set(form.InquiryActivity, 3, v ? true : false)">上课和会议</el-checkbox>
      <p>远距离 +近距离双重用眼需求,了解眼睛功能是否能匹配远近切换的用眼清晰度及舒适度</p>
    </div>
    <div class="yycj">
      <el-checkbox :value="!!form.InquiryActivity[4]" @input="(v) => $set(form.InquiryActivity, 4, v ? true : false)">运动锻炼</el-checkbox>
      <p>是否需要专门的运动场景设计的眼镜</p>
    </div>
    <div class="yycj">
      <el-checkbox :value="!!form.InquiryActivity[5]" @input="(v) => $set(form.InquiryActivity, 5, v ? true : false)">旅行与户外</el-checkbox>
      <p>是否需要用阳光防护镜片来保护眼健康</p>
    </div>
    <div class="yycj">
      <el-checkbox :value="!!form.InquiryActivity[6]" @input="(v) => $set(form.InquiryActivity, 6, v ? true : false)">日常生活</el-checkbox>
    </div>
    <!-- InquiryActivityDes: string 主要用眼场景描述 -->
    <input class="hxsr" type="text" v-model="form.InquiryActivityDes">



    <!-- ==================== 5、以下哪种场景下使用眼镜更多 ==================== -->
    <p class="bt1" style="margin-top: 30px;">5、以下哪种场景下使用眼镜更多:</p>
    <!-- InquiryScene: List<bool> 哪个用眼场景多，复选，5个 -->
    <ul class="cjgd">
      <li>
        <el-checkbox :value="!!form.InquiryScene[0]" @input="(v) => $set(form.InquiryScene, 0, v ? true : false)">看远距离</el-checkbox>
        <p>户外</p>
      </li>
      <li>
        <el-checkbox :value="!!form.InquiryScene[1]" @input="(v) => $set(form.InquiryScene, 1, v ? true : false)">看中距离</el-checkbox>
        <p>室内</p>
      </li>
      <li>
        <el-checkbox :value="!!form.InquiryScene[2]" @input="(v) => $set(form.InquiryScene, 2, v ? true : false)">看近距离</el-checkbox>
        <p>办公</p>
      </li>
      <li>
        <el-checkbox :value="!!form.InquiryScene[3]" @input="(v) => $set(form.InquiryScene, 3, v ? true : false)">远中切换</el-checkbox>
        <p>户外+室内</p>
      </li>
      <li>
        <el-checkbox :value="!!form.InquiryScene[4]" @input="(v) => $set(form.InquiryScene, 4, v ? true : false)">中近切换</el-checkbox>
        <p>室内+办公</p>
      </li>
    </ul>
    <!-- InquirySceneDes: string 哪个用眼场景多描述 -->
    <input class="hxsr" type="text" v-model="form.InquirySceneDes">




    <!-- ==================== 6、身体健康情况描述 ==================== -->
    <p class="bt1" style="margin-top: 30px;">6、身体健康情况描述:</p>
    <!-- InquiryOperation: bool 是否眼科手术 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否做过眼科手术：</p>
        <p>了解是否有做过影响视力及视觉质量的手术</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryOperation" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryOperation" :label="false">否</el-radio>
      </div>
    </div>
    <!-- InquiryEyeDisease: bool 眼病史 + InquiryEyeDisease_Des: string 描述 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否有眼病史：</p>
        <p>了解视力下降是屈光问题还是眼病问题</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryEyeDisease" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryEyeDisease" :label="false">否</el-radio>
        <input type="text" style="width: 15vw;" v-model="form.InquiryEyeDisease_Des">
      </div>
    </div>
    <!-- InquiryALlergy: bool 过敏史 + InquiryALlergy_Des: string 描述 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否有过敏史:</p>
        <p>了解对哪些过敏,给最终处方时要规避此影响</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryALlergy" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryALlergy" :label="false">否</el-radio>
        <input type="text" style="width: 15vw;" v-model="form.InquiryALlergy_Des">
      </div>
    </div>
    <!-- InquiryHBP: bool 高血压高血糖 + InquiryHBP_Des: string 描述 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.血糖血压是否偏高:</p>
        <p>了解血糖、血压是否影响眼健康及视力</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryHBP" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryHBP" :label="false">否</el-radio>
        <input type="text" style="width: 15vw;" v-model="form.InquiryHBP_Des">
      </div>
    </div>

    <!-- InquiryRemark: string 备注 -->
    <div class="qitsq" style="padding-top: 20px;">
      <p>备注:</p>
      <input type="text" v-model="form.InquiryRemark">
    </div>

    <div style="padding-top: 20px;">
      <el-button type="primary" @click="handleSave">保存</el-button>
    </div>
  </div>
</template>


<script>
import axios from "@/api/axios"

export default {
  name: "bsdwzCN",
  data() {
    return {
      // 主表单数据，字段与后端文档完全一致
      form: {
        InquiryChooseId: "",
        InquiryEditTime: "",
        // 1、主诉 [bool] x11
        InquiryIntention: [false, false, false, false, false, false, false, false, false, false, false],
        InquiryIntentionDes: "",
        // 2、旧镜史相关
        InquiryCorrection: [false, false, false, false, false, false],
        InquiryFormerLensType: [false, false, false, false, false, false, false],
        InquiryFormerLensClear: "",
        InquiryFormerLensComfortable: "",
        InquiryFitTimeForChange: "",
        InquiryChangeGlassesDegree: "",
        InquiryGlassesAmount: "",
        InquiryShortDistance: false,
        InquiryFullDay: false,
        InquiryFormerLensProblem: "",
        // 3、用眼需求相关
        InquiryDriveTime: [false, false, false],
        InquiryNightDrive: [false, false, false],
        InquiryShortViewTime: [false, false, false],
        InquiryOffLight: false,
        InquiryShortViewProblem: [false, false, false, false, false],
        InquiryChangeViewProblem: false,
        // 4、主要用眼场景
        InquiryActivity: [false, false, false, false, false, false, false],
        InquiryActivityDes: "",
        // 5、哪种场景下使用眼镜更多
        InquiryScene: [false, false, false, false, false],
        InquirySceneDes: "",
        // 6、身体健康情况描述
        InquiryOperation: false,
        InquiryEyeDisease: false,
        InquiryEyeDisease_Des: "",
        InquiryALlergy: false,
        InquiryALlergy_Des: "",
        InquiryHBP: false,
        InquiryHBP_Des: "",
        // 备注
        InquiryRemark: ""
      }
    }
  },
  created() {
    const id = this.$store.state.physicianVisits.xzConsulting
    if (!id) return

    const log = this.$loading({ text: '加载中...' })
    axios.post(this._getUrl('InquiryBSD_Get'), {
      "token": {
        "TimeSpan": 1724754569,
        "sToken": "8D6BB1DF4BDAB60B6F3B46A77D9A4530"
      },
      "SearchCondition": {
        "ChooseId": id
      }
    }).then(res => {
      log.close()
      if (res && res.Result) {
        this.normalizeData(res.Result)
      }
    }).catch(err => {
      log.close()
      console.error("bsdwzCN load error:", err)
    })
  },
  computed: {
    // 每天开车多长时间：单选，映射到 InquiryDriveTime 数组（仅一项为 true）
    driveTime: {
      get() {
        const i = this.form.InquiryDriveTime.findIndex(v => !!v)
        return i === -1 ? null : i
      },
      set(val) {
        this.form.InquiryDriveTime = [false, false, false]
        if (val !== null && val !== undefined && val !== '') {
          this.$set(this.form.InquiryDriveTime, val, true)
        }
      }
    },
    // 夜间开车问题：单选，映射到 InquiryNightDrive 数组
    nightDrive: {
      get() {
        const i = this.form.InquiryNightDrive.findIndex(v => !!v)
        return i === -1 ? null : i
      },
      set(val) {
        this.form.InquiryNightDrive = [false, false, false]
        if (val !== null && val !== undefined && val !== '') {
          this.$set(this.form.InquiryNightDrive, val, true)
        }
      }
    },
    // 每天近距离时长：单选，映射到 InquiryShortViewTime 数组
    shortViewTime: {
      get() {
        const i = this.form.InquiryShortViewTime.findIndex(v => !!v)
        return i === -1 ? null : i
      },
      set(val) {
        this.form.InquiryShortViewTime = [false, false, false]
        if (val !== null && val !== undefined && val !== '') {
          this.$set(this.form.InquiryShortViewTime, val, true)
        }
      }
    }
  },
  methods: {
    // 获取时直接使用后端返回的数据，不做转换；仅对 null/undefined 兜底，避免覆盖默认值
    normalizeData(data) {
      Object.keys(data).forEach(k => {
        if (data[k] == null) delete data[k]
      })
      this.form = Object.assign({}, this.form, data)
    },

    // 构建保存用的数据（补全 ChooseId）
    buildSaveData() {
      return Object.assign({}, this.form, {
        InquiryChooseId: this.$store.state.physicianVisits.xzConsulting
      })
    },

    // 保存
    handleSave() {
      const o = this.buildSaveData()

      const log = this.$loading({ text: '保存中...' })
      axios.post(this._getUrl('InquiryBSD_Update'), {
        "token": {
          "TimeSpan": 1566827733,
          "sToken": "768DCAFFF869CD61372790C2738012EC"
        },
        o: o,
      }).then(res => {
        log.close()
        this.$alert(res.displaymsg)
      }).catch(err => {
        log.close()
        this.$alert('保存失败，请稍后再试')
        console.error("bsdwzCN save error:", err)
      })
    }
  }
}
</script>


<style scoped lang="scss">
.bsdwzCN {
  width: 90%;
  margin: 0 auto;
  padding-bottom: 20px;
}

.bt1 {
  text-align: left;
  padding: 5px 10px;
  background: #e5e5e5;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 20px;
}
.sjwt {
  display: flex;
  text-align: left;
  padding-bottom: 15px;
  p {
    width: 33%;
    span {
      display: block;
      font-size: 13px;
      color: #8eb2ff;
      padding-left: 25px;
    }
  }
}

.qitsq {
  display: flex;
  align-content: center;
  input {
    width: calc(100% - 150px);
    margin-left: 20px;
    border: none;
    border-bottom: 1px solid #000000;
  }
}

.slxgbox {
  display: flex;
  align-content: center;
  text-align: left;
  border-bottom: 1px dashed #818181;
  padding-bottom: 5px;
  margin-bottom: 10px;
  .slxgbox-a {
    width: 62%;
    p{color: #8eb2ff;font-size: 14px;}
    p:nth-child(1) {color: #000000;}
  }
  input {
    width: 50px;
    border: none;
    border-bottom: 1px solid #000000;
    text-align: center;
  }
}

.yycj {
  display: flex;
  padding-bottom: 10px;
  font-size: 14px;
  p {
    color: #8eb2ff;
    position: relative;
    top: -3px;
    padding-left: 20px;
  }
}
.hxsr {
  width: 100%;
  border: none;
  border-bottom: 1px solid #000000;
  padding-top: 20px;
}

.cjgd {
  display: flex;
  font-size: 14px;
  li {
    margin-right: 10%;
    p {
      text-align: left;
      color: #8eb2ff;
      position: relative;
      left: 25px;
    }
  }
}
</style>
